import { Choices } from '@/shared/Choices'

export default Choices
